import { Paper, TableContainer } from '@mui/material';
import React, { useRef,useEffect } from 'react'
import { useSelector } from 'react-redux';
import ListingTable from '../../../listing/listing';

export default function AllActivitiesList
({listData,setSearchGridData,setsearchBtnClick}) {

  let mindate = useSelector((state) =>
  state.DashboardReducer?.mindate ? state.DashboardReducer.mindate : {}
);
let maxDate = useSelector((state) =>
  state.DashboardReducer?.maxDate ? state.DashboardReducer.maxDate : {}
);

let gridData = useSelector(state=>state.tableSlice?.otherResData?. AllAactableDataDashboard?.grid_data ? state.tableSlice.otherResData. AllAactableDataDashboard.grid_data: [])
const searchFormData = useSelector((state) =>state.formSlice?.formData?.searchForallactivity ? state.formSlice.formData.searchForallactivity : {} );
const searchForallactivity = useSelector((state) =>state.formSlice?.formSubmissionState?.searchForallactivity ? state.formSlice.formSubmissionState.searchForallactivity : {} );
useEffect(()=>{
  if(searchForallactivity === 4){
    setsearchBtnClick(1)
  }
},[searchForallactivity])
useEffect(() => {
  AllAactableDataDashboard.current.searchData.formData.fields.forEach((data) => {
      data.defaultValue=searchFormData[data.name]?searchFormData[data.name]:undefined
      console.log("searchFormData", searchFormData,data);
      })
  
}, [JSON.stringify(searchFormData)]); 




      var modifyTableHeaders = [
        { val: "user_name", name: "User Name" },
        { val: "user_email", name: "User Email" },
        { val: "user_phone", name: "User Phone" },
        { val: "added_for_name", name: "Email Recieved by" },
        { val: "added_for_email", name: "Added For Email" },
        { val: "added_for_phone", name: "Added For" },
    
      ];

      useEffect(()=>{
        setSearchGridData(gridData)
        console.log("gridData",gridData);
      },[JSON.stringify(gridData)])

      let AllAactableDataDashboard = useRef({
        tableId: "AllAactableDataDashboard",
        tableTitle: "All Activities List View",
        showReload: true,
        showFilter: true,
        // adduser: true,
        api: {
          url: process.env.REACT_APP_API_URL,
          endPoint: "users/admin-dashboard-list-grid",
          deleteSingleUserEndpoint: "",
          tableCountEndpoint: "users/admin-dashboard-list-grid",
        },
    
        reqBody: {
          condition: {
            limit: 5,
            skip: 0,
          },
          sort: {
            field: "_id",
            type: "desc",
          },
          searchcondition: {
            createdon_datetime: {
              // $gte: mindate,
              $lte: maxDate,
            },
          },
          source:"activity_list",
          type:"activity_deatails",
          project: {},
          token: "",
          count: false,
        },
        deleteSingleUserReqBody: {
          source: "users",
          secret: "AZ|lepL`",
        },
        deleteMultipleReqBody: {
          source: "users",
          secret: "AZ|lepL`",
        },
    
        //******************************** By Default Rows per page option will be available**************************//
    
        rowsPerPageOptions: [5],
        sortFields: ["user_name", "user_email", "added_for_name", "added_for_email"],
        paginationType: "stackPagination",
        enableRowActionLoader: true,
        customBtnHead: [
          {
            id: "delete",
            label: "Delete",
            type: "api",
            category: "modal",
            icon_type: "delete",
            className: "delete_data",
            modalClassName: "delete_modal",
            modalTitle:
              "<p>Are you sure that you want to delete this record(s)?</p>",
            btn_label: ["Yes", "No"],
            api_data: {
              base_url: process.env.REACT_APP_API_URL,
              endpoint: "",
              body: {
                source: "users",
                secret: "AZ|lepL`",
                token:
                  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmb28iOiJiYXIiLCJleHAiOjE2NTIxNjM3MDUsImlhdCI6MTY1MjA3NzMwNX0.3kB4iRr5JbmV81Dl5gKA7fiTaMEEp0xbsWoO-wA0XUo",
              },
            },
          },
          {
            id: "status",
            label: "Change Status",
            type: "api",
            category: "status",
            icon_type: "toggle_off",
            className: "status_data",
            modalClassName: "delete_modal",
            modalHeader: "<p> Alert !!</p>",
            modalTitle: "<p>Are you sure you want to change the status ?</p>",
            btn_label: ["Active", "Inactive"],
            api_data: {
              base_url: process.env.REACT_APP_API_URL,
              endpoint: "",
              body: {
                source: "users",
                secret: "AZ|lepL`",
                token:
                  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmb28iOiJiYXIiLCJleHAiOjE2NTIxNjM3MDUsImlhdCI6MTY1MjA3NzMwNX0.3kB4iRr5JbmV81Dl5gKA7fiTaMEEp0xbsWoO-wA0XUo",
              },
            },
          },
        ],
        buttons: [
          
          {
            id: "summarize_icon",
            label: "Notes",
            type: "other",
            name: "summarize_icon",
            title: "Notes",
          },
          {
            id: "folder_icon",
            label: "Folder View",
            type: "other",
            name: "folder_icon",
            title: "Folder View",
          },
          {
            id: "assessment_icon",
            label: "Training Report",
            type: "other",
            name: "assessment_icon",
            title: "Training Report",
          },
          {
            id: "streetview_icon",
            label: "Leads",
            type: "other",
            name: "streetview_icon",
            title: "Leads",
          },
        ],
        deleteModal: {
          modalClassName: "modalblock",
        },
    
        searchData: {
          heading: "Search All Activities ",
          type: "drawer",
          formData: {
            id: 'searchForallactivity',
            formWrapperClass: "formWrapperClass",
            formInlineCLass: "userForm", 
            formButtonClass: "submitbtnsection",
            submitBtnName: "Search",
            resetBtnName: "Refresh",
            submitBtnEndIcon: "search",
            resetBtnEndIcon: "replay",
            resetForm: true,
            formAdditionalSubmissionData: {},
            fields: [
              {
                id: 1,
                label: "Search By User Name",
                name: "name",
                type: "autoComplete",
                className: 'list_search_item countDiv__column--col2 ',
                base_url: process.env.REACT_APP_API_URL + "dashboard-cards/all-activities",
                reqBody: {
                  "condition": {
                      "limit": 5,
                      "skip": 0
                  },
                  "sort": {
                      "type": "asc",
                      "field": "email"
                  },
                  "searchcondition": {
                    activity_time: {
                      // $gte: mindate,
                      $lte: maxDate,
                    },
                     
                  },
                  "type": "user_name",
                  "source": "activity_list"
              },
                sx: { m: 1, minWidth: 300 },
                // payloadFormat: { key: "_id", param: "$regex", options: "i" },
                payloadFormat: { key: "user_id" },
    
              },
           
              {
                id: 2,
                label: "Search By User Email ",
                name: "data_base_variable",
                type: "autoComplete",
                className: 'list_search_item countDiv__column--col2 ',
                base_url: process.env.REACT_APP_API_URL + "dashboard-cards/all-activities",
                reqBody: {
                  "condition": {
                      "limit": 5,
                      "skip": 0
                  },
                  "sort": {
                      "type": "asc",
                      "field": "email"
                  },
                  "searchcondition": {
                    activity_time: {
                      // $gte: mindate,
                      $lte: maxDate,
                    },
                     
                  },
                  "type": "user_email",
                  "source": "activity_list"
              },
                sx: { m: 1, minWidth: 300 },
                payloadFormat: { key: "user_id" },
    
              },


              {
                  id: 3,
                  label: "Search Email Recieved by",
                  name: "for_name",
                  type: "autoComplete",
                  className: 'list_search_item countDiv__column--col6 ',
                  base_url: process.env.REACT_APP_API_URL + "dashboard-cards/all-activities",
                  reqBody:{
                    "condition": {
                        "limit": 5,
                        "skip": 0
                    },
                    "sort": {
                        "type": "asc",
                        "field": "email"
                    },
                    "searchcondition": {
                      activity_time: {
                        // $gte: mindate,
                        $lte: maxDate,
                      },
                       
                    },
                    "type": "added_for_name",
                    "source": "activity_list"
                },
                  sx: { m: 1, minWidth: 300 },
                  payloadFormat: { key: "_id" },
      
                },


                {
                  id: 4,
                  label: "Search Added For Email",
                  name: "for_email",
                  type: "autoComplete",
                  className: 'list_search_item countDiv__column--col6 ',
                  base_url: process.env.REACT_APP_API_URL + "dashboard-cards/all-activities",
                  reqBody: {
                    "condition": {
                        "limit": 5,
                        "skip": 0
                    },
                    "sort": {
                        "type": "asc",
                        "field": "email"
                    },
                    "searchcondition": {
                      activity_time: {
                        // $gte: mindate,
                        $lte: maxDate,
                      },
                       
                    },
                    "type": "added_by_email",
                    "source": "activity_list"
                },
                  sx: { m: 1, minWidth: 300 },
                  payloadFormat: { key: "_id" },
      
                },
            ]
          }
        },
      });
  return (
    <>
    <TableContainer component={Paper}>
          <ListingTable
            tableData={AllAactableDataDashboard.current}
            dataset={listData}
            modifyHeaders={modifyTableHeaders}
          />
        </TableContainer>
    </>
  )
}
